var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "任务号",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c("a-input", {
                                    attrs: { placeholder: "请输入任务号查询" },
                                    model: {
                                      value: _vm.queryParam.taskNo,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "taskNo", $$v)
                                      },
                                      expression: "queryParam.taskNo",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                {
                                  attrs: {
                                    label: "状态",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                  },
                                },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      attrs: {
                                        allowClear: "",
                                        placeholder: "请选择状态",
                                      },
                                      model: {
                                        value: _vm.queryParam.status,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryParam,
                                            "status",
                                            $$v
                                          )
                                        },
                                        expression: "queryParam.status",
                                      },
                                    },
                                    _vm._l(
                                      _vm.statusMap,
                                      function (name, status) {
                                        return _c(
                                          "a-select-option",
                                          {
                                            key: status,
                                            attrs: { value: status },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(name) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass: "table-page-search-submitButtons",
                              staticStyle: {
                                float: "left",
                                overflow: "hidden",
                              },
                            },
                            [
                              _c(
                                "a-col",
                                { attrs: { md: 12, sm: 24 } },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.searchQuery },
                                    },
                                    [_vm._v("查询")]
                                  ),
                                  _c(
                                    "a-button",
                                    {
                                      staticStyle: { "margin-left": "8px" },
                                      on: { click: _vm.searchReset },
                                    },
                                    [_vm._v("重置")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "table-operator",
                  staticStyle: { "margin-top": "5px" },
                },
                [
                  _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "plus" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("创建配送任务")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "section",
                [
                  _c("a-table", {
                    ref: "table",
                    attrs: {
                      size: "middle",
                      bordered: "",
                      rowKey: "id",
                      columns: _vm.columns,
                      dataSource: _vm.dataSource,
                      pagination: false,
                      scroll: _vm.scroll,
                      loading: _vm.loading,
                    },
                    on: { change: _vm.handleTableChange },
                    scopedSlots: _vm._u([
                      {
                        key: "status",
                        fn: function (text, record) {
                          return [
                            _c(
                              "a-tag",
                              { attrs: { color: _vm.statusColor[text] } },
                              [
                                _vm._v(
                                  _vm._s(
                                    record.statusName ||
                                      _vm.statusMap[text] ||
                                      text
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                      {
                        key: "routeMode",
                        fn: function (text, record) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(record.routeModeName || "-")),
                            ]),
                            record.routeSummary
                              ? _c("div", { staticClass: "route-summary" }, [
                                  _vm._v(_vm._s(record.routeSummary)),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "progress",
                        fn: function (text, record) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(record.signedCount) +
                                "/" +
                                _vm._s(record.stopCount) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                      {
                        key: "action",
                        fn: function (text, record) {
                          return _c("span", {}, [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(record)
                                  },
                                },
                              },
                              [_vm._v("详情")]
                            ),
                          ])
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("a-pagination", {
                staticStyle: { "margin-top": "16px", "text-align": "right" },
                attrs: {
                  current: _vm.ipagination.current,
                  pageSize: _vm.ipagination.pageSize,
                  total: _vm.ipagination.total,
                },
                on: {
                  change: _vm.paginationChange,
                  showSizeChange: _vm.paginationShowSizeChange,
                },
              }),
              _c("delivery-task-create-modal", {
                ref: "createModal",
                on: { ok: _vm.modalFormOk },
              }),
              _c("delivery-task-detail-modal", { ref: "detailModal" }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }